var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('AddToNestForm',{ref:"addToNestForm",attrs:{"value":"username","button":"➕ add to nest"}}),_vm._m(0),_c('section',_vm._l((_vm.$store.getters.getNestMembers(_vm.$route.params.nestId)),function(user){return _c('MemberComponent',{key:user.id,attrs:{"user":user}})}),1),_c('p',[_vm._v("End of Nest's Members")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h1',[_vm._v(" Chirpers in Nest ")])])
}]

export { render, staticRenderFns }